var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsNotEmpty, IsOptional, IsString, IsUUID, MaxLength } from 'class-validator';
import { Transform } from 'class-transformer';
/**
 * Body of `POST /challenge/start`. The access code is optional in the wire
 * format: when the server has no `CHALLENGE_ACCESS_CODE` env var, the gate is
 * disabled and clients may omit it. When the env var is set, the server
 * rejects a missing / wrong code with 401.
 */
export class StartChallengeSessionDto {
    accessCode;
    /**
     * Free-text label identifying the participant — the one piece of real PII
     * captured in challenge mode. Required (non-empty after trim) and used only
     * as a viewer-side label; never rendered inside the challenge app itself.
     */
    participantName;
    /**
     * Client-generated UUID correlating this start request with the transient
     * provisioning-progress stream the frontend polls at
     * `GET /challenge/provisioning/:correlationId` while this request is pending.
     * Optional: when omitted, provisioning runs exactly as before with no
     * progress published (e.g. e2e/test callers that don't care about progress).
     */
    correlationId;
}
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(200),
    __metadata("design:type", String)
], StartChallengeSessionDto.prototype, "accessCode", void 0);
__decorate([
    IsString(),
    Transform(({ value }) => (typeof value === 'string' ? value.trim() : value)),
    IsNotEmpty(),
    MaxLength(200),
    __metadata("design:type", String)
], StartChallengeSessionDto.prototype, "participantName", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    __metadata("design:type", String)
], StartChallengeSessionDto.prototype, "correlationId", void 0);
//# sourceMappingURL=start-challenge-session.dto.js.map